import type { User } from "@auth/user";
import type { ISpaceLoginResponse } from "@/api/space/dtos/authenticator.dto";
import { DEFAULT_GROUP_ID } from "@/configs/runtime";
import { getUserPermissionName, inferIsSpaceUser, normalizeCompanyAccess } from "./utilitariosJwt";

type OpcoesMapeamentoUsuario = {
	groupIdPadrao?: string;
	ehUsuarioSpace?: boolean;
};

export function mapearRespostaLoginParaUsuario(
	respostaLogin: ISpaceLoginResponse,
	opcoes: OpcoesMapeamentoUsuario = {},
): User {
	const ehUsuarioSpaceInferido = inferIsSpaceUser({
		username: respostaLogin.nome,
	});

	const ehUsuarioSpaceFinal = opcoes.ehUsuarioSpace ?? ehUsuarioSpaceInferido;
	const groupIdPadrao = Number(opcoes.groupIdPadrao ?? DEFAULT_GROUP_ID);

	return {
		permissoes: getUserPermissionName(respostaLogin.nome_cad_grupo_usuario),
		nome: respostaLogin.nome,
		nome_cad_grupo_usuario: respostaLogin.nome_cad_grupo_usuario,
		nome_exibicao: respostaLogin.nome ?? "",
		nome_usuario: respostaLogin.nome ?? "",
		photo: undefined,
		empresa_acesso: normalizeCompanyAccess(respostaLogin.empresa_acesso),
		id_cad_pessoa: respostaLogin.id_cad_pessoa,
		id_cad_pessoa_funcionario: respostaLogin.id_cad_pessoa_funcionario,
		id_cad_grupo: groupIdPadrao,
		id_cad_grupo_usuario: respostaLogin.id_cad_grupo_usuario,
		platform: "Flow",
		eh_usuario_space: ehUsuarioSpaceFinal,
		autenticacao_dois_fatores: Boolean(respostaLogin.autenticacao_dois_fatores),
	};
}
